let _uid = 0;

/**
 * Exposes the ability to add workflow components to the Web Viewer. Workflows should include a component to render
 * when enabled, an icon used to enable it, and the i18n key to show when hovering over the icon. Sample registration:
 * ```javascript
 * WebViewer.addWorkflow({
 *      component: MyVueComponent,
 *      icon: require('my-40px-icon.png'),
 *      title: 'my-i18n-key'
 * ```
 * @param WebViewer
 */
export function initWorkflow (WebViewer) {
  const installedWorkflows = [];

  WebViewer.addWorkflow = function (workflow) {
    if (installedWorkflows.indexOf(workflow) > -1) {
      return this;
    }

    // Assign a unique key for enumeration in v-for bindings.
    workflow.key = _uid++;

    installedWorkflows.push(workflow);

    return this;
  };

  WebViewer.prototype.workflows = installedWorkflows;
}



// WEBPACK FOOTER //
// ./src/viewer/core/global-api/workflow.js